import styled from 'styled-components';

export const DropdownExtraMessage = styled.div`
  color: ${({ theme }) => theme.topicMetaData.color.label};
  font-size: 14px;
  width: 100%;
  margin-top: 10px;
`;
